var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 78,
    viewBox: "0 0 64 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9925 52.4777H57.9319C57.2311 39.1134 46.5085 28.3907 33.1438 27.69V17.9529H49.7157C50.4789 17.9529 51.0967 17.3351 51.0967 16.5719V5.52409C51.0967 4.76088 50.4789 4.14307 49.7157 4.14307H33.1438V0H30.3817V5.52409V16.5719V27.69C17.0174 28.3907 6.29477 39.1134 5.59398 52.4777H5.53343C2.48285 52.4777 0 54.9549 0 58.0018C0 61.0486 2.48285 63.5259 5.53343 63.5259H6.90511V75.9547C6.90511 76.7179 7.52292 77.3357 8.28613 77.3357H55.2397C56.003 77.3357 56.6208 76.7179 56.6208 75.9547V63.5259H57.9925C61.043 63.5259 63.5259 61.0486 63.5259 58.0018C63.5263 54.9549 61.0434 52.4777 57.9925 52.4777ZM33.1445 6.90511H48.3354V15.1909H33.1445V6.90511ZM31.7635 30.3817C44.245 30.3817 54.4825 40.1726 55.1998 52.4777H8.32687C9.0441 40.1726 19.2816 30.3817 31.7635 30.3817ZM53.8587 74.5733H9.66715V63.5255H53.8587V74.5733ZM57.9925 60.7635H55.2397H8.28613H5.53343C4.00552 60.7635 2.76204 59.5241 2.76204 58.0014C2.76204 56.4787 4.00552 55.2394 5.53343 55.2394H6.90511H56.6208H57.9925C59.5204 55.2394 60.7638 56.4787 60.7638 58.0014C60.7642 59.5241 59.5207 60.7635 57.9925 60.7635Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6203 34.5248H23.4773V37.2868H27.6203V34.5248Z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2876 40.0488H33.1445V42.8109H37.2876V40.0488Z",
    fill: "#FF5F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3348 44.1914H15.1917V46.9534H19.3348V44.1914Z",
    fill: "#FF5F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3354 45.5726H44.1923V48.3347H48.3354V45.5726Z",
    fill: "#FF5F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7631 46.9536H27.62V49.7157H31.7631V46.9536Z",
    fill: "#FF5F00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.96e41e5a032dd43c6f2beffc0c4ad709.svg";
export { ForwardRef as ReactComponent };